// extracted by mini-css-extract-plugin
export default {"content-container":"iframeviewer_content-container__70gkm","content-container-text":"iframeviewer_content-container-text__t2fut"};